<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogType',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-member-type-dialog'" :title="state.dialog.title"
    width="550px" :ok-text="state.dialog.submitTxt" @ok="onSubmit" @cancel="closeDialog" :closable="false"
    :maskClosable="false">
    <a-form ref="formRef" :model="state.ruleForm" :label-col="{ style: 'width: 90px' }"
      :wrapper-col="{ style: 'flex: 1' }">
      <a-form-item label="角色类型" name="roleType">
        <a-select v-model:value="state.ruleForm.roleType" placeholder="角色类型" allow-clear>
          <a-select-option v-for="item in state.userTagList" :key="item.code" :value="item.code">{{ item.name
          }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogType">
import { reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { useMember } from '@/store/system/member'
const memberStore = useMember()

const emit = defineEmits(['create'])

const formRef = ref()

const state = reactive({
  ruleForm: {
    id: '',
    roleType: ''
  },
  userTagList: [] as any[],
  dialog: {
    visible: false,
    title: '设置角色类型',
    submitTxt: '修改'
  }
})

onMounted(async () => {
  const res: any = await memberStore.getDict({ code: 'user_type' })
  state.userTagList = res || []
})

const openDialog = async (row: any) => {
  state.ruleForm.id = row.userId
  state.ruleForm.roleType = row.type
  state.dialog.visible = true
}

const closeDialog = () => {
  state.dialog.visible = false
}

const onSubmit = () => {
  if (!state.ruleForm.roleType) {
    message.error('请选择角色类型')
    return
  }
  emit('create', { ...state.ruleForm })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>
